import { render, staticRenderFns } from "./RearBackWheel.vue?vue&type=template&id=3f52af4a"
import script from "./RearBackWheel.vue?vue&type=script&lang=js"
export * from "./RearBackWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports